import Globals from '../../globals'
import * as R from 'ramda'
import { dateComparator, formatDate } from '../../../util/datetime'


export const enrichLeadList = (state, leadList) => {
    R.forEach(lead => {
        enrichLead(state, lead)
    }, leadList)
}

export const enrichLead = (state, lead) => {
    lead.statusName = Globals.selector.selectLeadStatusValueById(state, lead.status)
    lead.responsibleEmployeeName = Globals.selector.selectEmployeeNameById(state, lead.responsibleEmployeeId)
    lead.lastStateTransition = formatDate(lead.lastStatusChange)

    R.forEach(statusHistory => {
        statusHistory.statusName = Globals.selector.selectLeadStatusValueById(state, statusHistory.newStatus)
        statusHistory.changedByEmployeeName = Globals.selector.selectEmployeeNameById(state, statusHistory.changeByEmployeeId)
    }, lead.statusHistory)
    lead.statusHistory.sort(dateComparator('changed'))
}



// WEBPACK FOOTER //
// ./src/modules/lead/state/enrich-lead.js